import { useModal } from "components/ModalGlobal";
import { parseDateBR } from "helpers/date";
import { maskDocument } from "helpers/document";
import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap";
import AdminRequestService from "services/admin-request";

function TableListCompanies({ list, blockChange, listBlocked }) {
  const [filter, setFilter] = useState({
    quantity: 20, name: ""
  });

  const listShow = useMemo(() => {
    return list.filter(item => {
      if(listBlocked.includes(item.id)){
        return false;
      }
      if (!!filter.search) {
        return (
          item.name.toLowerCase().indexOf(filter.search.toLowerCase()) != -1
          ||
          item.document.indexOf(filter.search) != -1
          ||
          maskDocument(item.document).indexOf(filter.search) != -1
        );
      }
      return true;
    }).slice(0, filter.quantity);
  }, [list, filter, listBlocked]);

  return (
    <>
      <label>Lista de empresas</label>
      <div className="area-table">
        <input placeholder="Pesquisar" onInput={(e) => {
          let value = e.target.value;
          setFilter(old => ({ ...old, quantity: 20, search: value }))
        }} />
        <div className="area-table-pagination" onScroll={(e) => {
          const currentScrollY = e.target.scrollTop;
          const scrollHeight = e.target.scrollHeight - e.target.offsetHeight;
          if (currentScrollY > scrollHeight) {
            if (list.length > filter.quantity) {
              setFilter(old => ({ ...old, quantity: old.quantity + 10 }))
            }
          }
        }}>
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CNPJ</th>
                <th style={{ width: "0px" }}></th>
              </tr>
            </thead>
            <tbody>
              {listShow.map((item, index) => {
                return <tr key={index}>
                  <td>{item.name}</td>
                  <td>{maskDocument(item.document)}</td>
                  <td>
                    <Button size="sm" onClick={() => blockChange(1, item.id)}>Aplicar exceção</Button>
                  </td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

function TableBlockedCompanies({ list, blockChange }) {
  const [filter, setFilter] = useState({
    quantity: 20, name: ""
  });

  const listShow = useMemo(() => {
    return list.filter(item => {
      if (!!filter.search) {
        return (
          item.name.toLowerCase().indexOf(filter.search.toLowerCase()) != -1
          ||
          item.document.indexOf(filter.search) != -1
          ||
          maskDocument(item.document).indexOf(filter.search) != -1
        );
      }
      return true;
    }).slice(0, filter.quantity);
  }, [list, filter]);

  return (
    <>
      <label>Lista de empresas com exceção</label>
      <div className="area-table">
        <input placeholder="Pesquisar" onInput={(e) => {
          let value = e.target.value;
          setFilter(old => ({ ...old, quantity: 20, search: value }))
        }} />
        <div className="area-table-pagination" onScroll={(e) => {
          const currentScrollY = e.target.scrollTop;
          const scrollHeight = e.target.scrollHeight - e.target.offsetHeight;
          if (currentScrollY > scrollHeight) {
            if (list.length > filter.quantity) {
              setFilter(old => ({ ...old, quantity: old.quantity + 10 }))
            }
          }
        }}>
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CNPJ</th>
                <th style={{ width: "0px" }}></th>
              </tr>
            </thead>
            <tbody>
              {listShow.map((item, index) => {
                return <tr key={index}>
                  <td>{item.name}</td>
                  <td>{maskDocument(item.document)}</td>
                  <td>
                    <Button size="sm" onClick={() => blockChange(0, item.id)}>Remover exceção</Button>
                  </td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

function Message(){
  const [message, setMessage] = useState({
    message:"",
    loading:true
  })

  useEffect(()=>{
    AdminRequestService.getMessageActionBlockedCompanies().then(({data})=>{
      setMessage({message:data.message,loading:false})
    })
  },[])

  return (
    <textarea style={{width:"100%"}} id="text-area-name-block-action" rows={10} defaultValue={message.message}/>
  );
}

function getNumber(n){
  let ns = `${n}`;
  if(ns.length == 1){
    return "0"+n;
  }
  return n;
}

export default function RedemptionRequestPeriod({companiesList}) {
  const [list] = useState(companiesList);
  const [listException, setListException] = useState({
    status:false,
    list:[]
  });
  const {showModal} = useModal();
  const [days] = useState(()=>{
    let r = [];
    for (let i = 1; i <= 31; i++) {
      r.push(i)
    }
    return r;
  })

  const [_from, _setFrom] = useState(1);
  const [_to, _setTo] = useState(1);
  const [_blockAll, _setBlockAll] = useState(false);

  useEffect(() => {
    AdminRequestService.getConfig("action_period.days.from").then(({data})=>{_setFrom(data.return)})
    AdminRequestService.getConfig("action_period.days.to").then(({data})=>{_setTo(data.return)})
    AdminRequestService.getConfig("action_period.days.block_all").then(({data})=>{_setBlockAll(data.return == "true")})
    AdminRequestService.getConfig("action_period.days.list_exception").then(({data})=>{setListException({status:true,list:JSON.parse(data.return)})})
  }, []);

  const blockChange = useCallback((is_blocked, company_id)=>{
    if(is_blocked==1){
      setListException(old=>{
        return {
          status:true,list:([...old.list, company_id])
        }
      });
    } else {
      setListException(old=>{
        return {
          status:true,list:old.list.filter(item=>item != company_id)
        }
      })
    }
  },[list])

  useEffect(()=>{
    if(listException.status){
      AdminRequestService.setConfig("action_period.days.list_exception",JSON.stringify(listException.list))
    }
  },[listException])

  function verify_data(){
    let date = new Date();
    let day = date.getDate();
    return _from <= day && _to >= day;
  }

  function getInfo(){
    if(_blockAll){
      return `Solicitação de resgate bloqueada por tempo indeterminado`;
    }
    let date = new Date();
    let month = date.getMonth() + 1;
    if(verify_data()){
      return `Estará disponível até ${getNumber(_to)}/${getNumber(month)}, após essa data só estará disponível novamente no dia ${getNumber(_from)}/${getNumber(month%12+1)}`;
    }
    return `No dia ${getNumber(_to)}/${getNumber(month)} o período de solicitação de resgate terminou, retornaremos no dia ${getNumber(_from)}/${getNumber(month%12+1)}`;
  }

  return (
    <Container>
      <Row className="justify-content-between align-items-center">
        <Col><h5>Período de solicitação de resgate</h5></Col>
      </Row>
      <hr />
      <div>
        <span>Bloquear indefinidamente </span><input type="checkbox" checked={_blockAll} onChange={(e)=>{
          _setBlockAll(e.target.checked)
          AdminRequestService.setConfig("action_period.days.block_all",e.target.checked);
        }}/>
      </div>
      <div>
        <span>Período de solicitação de resgate de </span>
        <select value={_from} disabled={_blockAll} onChange={(e)=>{
          _setFrom(e.target.value)
          AdminRequestService.setConfig("action_period.days.from",e.target.value);
        }}>
          {days.map((d)=>{
            return <option value={d} key={d}>{getNumber(d)}</option> 
          })}
        </select>
        <span> a </span>
        <select value={_to} disabled={_blockAll} onChange={(e)=>{
          _setTo(e.target.value)
          AdminRequestService.setConfig("action_period.days.to",e.target.value);
        }}>
          {days.map((d)=>{
            return <option value={d} key={d}>{getNumber(d)}</option> 
          })}
        </select>
      </div>
      <div>
        <pre>{getInfo()}</pre>
      </div>
      
      <TableBlockedCompanies list={listException.list.map(a=>list.find(item=>item.id==a))} blockChange={blockChange}/>
      <TableListCompanies list={list} blockChange={blockChange} listBlocked={listException.list}/>

    </Container>
  );
}